/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_LeaveInputs */

const en_us2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave the club`)
};

const pt_br2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair do clube`)
};

const es_419_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir del club`)
};

const pt_pt2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair do clube`)
};

const fr_fr2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter le club`)
};

const de_de2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club verlassen`)
};

const it_it2_clubs_leave = /** @type {(inputs: Clubs_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia il club`)
};

/**
* | output |
* | --- |
* | "Leave the club" |
*
* @param {Clubs_LeaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_leave = /** @type {((inputs?: Clubs_LeaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_LeaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_leave(inputs)
	if (locale === "es-419") return es_419_clubs_leave(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_leave(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_leave(inputs)
	if (locale === "de-DE") return de_de2_clubs_leave(inputs)
	if (locale === "it-IT") return it_it2_clubs_leave(inputs)
	return en_us2_clubs_leave(inputs)
});
export { clubs_leave as "clubs.leave" }